import type {CommonProps} from './types';

export default ({color = 'currentColor', size = 24, ...rest}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    {...rest}
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 22c-.507-1.667-3.918-3.618-9.843-3.887A1.5 1.5 0 0 1 .75 16.605V3.254a1.5 1.5 0 0 1 1.607-1.5 25.04 25.04 0 0 1 2.966.324M12 22c.507-1.667 3.918-3.618 9.843-3.887a1.5 1.5 0 0 0 1.407-1.507V3.254a1.5 1.5 0 0 0-1.607-1.5 25.116 25.116 0 0 0-2.842.3M12 15.978v6.021"
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.243 5.573a.933.933 0 0 0-.96.085L8.75 7.728H6.917a.908.908 0 0 0-.917.9v1.2a.908.908 0 0 0 .917.9H8.75l2.533 2.07a.929.929 0 0 0 .96.085.9.9 0 0 0 .507-.8v-5.7a.9.9 0 0 0-.507-.81ZM16.5 7.3a2.594 2.594 0 0 1 0 3.587"
    />
  </svg>
);
